export default __webpack_public_path__ + "static/media/NewBlogFeature-Breaking-Down-Web-Analytics-Referrer-Type.e42e7b18.png";